import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login/login";
import PatientList from "./pages/PatientList/patientList";
import AddPatient from "./pages/AddPatient/addPatient";
import PatientDetails from "./pages/PatientDetails/patientDetails";
import ModifyPassword from "./pages/ModifyPassword/modifyPassword";
import './App.css';

function App() {
  const [isMobileDevice, setIsMobileDevice] = useState(null);
  useEffect(() => {
    // 判断是手机端还是PC端
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const mobileCheck = () => {
      // 检查常见的移动设备标识
      if (/android/i.test(userAgent)) {
        return true;
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true;
      }
      // 其他移动设备的判断条件
      return /Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    }

    const isMobile = mobileCheck();
    setIsMobileDevice(isMobile);

    if (!isMobile) {
      console.log("当前设备是桌面设备");
      window.location.href = "https://amb.focusight.top/user/login";
    } else {
      console.log("当前设备是移动设备");
    }
  }, []);

  if (isMobileDevice === null) {
    // 在设备类型未确定之前，显示加载状态或空白内容
    return
  }

  console.log('isMobileDevice', isMobileDevice)

  return (
    <BrowserRouter>
      <div className='App'>
        <Routes>
          <Route exact path="/" element={<Login />} />
          {/* <Route exact path="/" element={redirectToList ? <Navigate to="/patientList" /> : <Login />} /> */}
          <Route exact path="/patientList" element={<PatientList />} />
          <Route exact path="/addPatient" element={<AddPatient />} />
          <Route exact path="/patientDetails" element={<PatientDetails />} />
          <Route exact path="/modifyPassword" element={<ModifyPassword />} />
        </Routes>
      </div>
    </BrowserRouter>
  );

}

export default App;
